export const url = "http://localhost:8000";
export const insta_token =
  "IGQWROQjM4Uk9hRVh1dXFta1ZAydWJTQlVwMThWYjFuNUIxVzA1blBOc0NWbTFJSjExcWQxaDFtS2xadUdWRXFvUXV0dHhxTnJiVTlqNFlXdnNKYjJqWFo0NEJCSHVITDNyeUdYZAUFuMW9Vbk1jTVVPMGZA0Ykt4UWsZD";
export const url_webapp = "https://www.webapp2.skillsscale.in";
